module.exports = __webpack_public_path__ + "img/my.48a721dc.jpg";